import styled from 'styled-components'
import { setPaddingSize } from '../../../utils/contentfulStyles.utils'

export const RelatedArticleItem = styled.div`
  > a {
    text-decoration: none;
  }

  &:hover {
    box-shadow: 0px 16px 16px -8px ${({ theme }) => theme.webMktNewPalette.alphaBlack[10]};
  }

  width: 384px;
  background: ${({ theme }) => theme.webMktNewPalette.white};
  cursor: pointer;

  &:not(:last-of-type) {
    margin-right: 24px;
  }

  .RelatedArticle__Item-Icon {
    position: absolute;
    right: 1px;
    bottom: 1px;
    height: 48px;
    width: 48px;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 304px;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    width: 360px;

    &:nth-of-type(1) {
      margin-right: 16px;
    }

    &:nth-of-type(2) {
      margin: 0;
    }

    &:nth-of-type(3) {
      margin-top: 16px;
    }
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    max-width: 329px;
    width: 100%;

    &:nth-of-type(1) {
      margin: 0;
    }

    &:nth-of-type(2),
    &:nth-of-type(3) {
      margin-top: 16px;
    }
  }
`

export const RelatedArticleContainer = styled.div<{
  $topPadding: string
  $bottomPadding: string
}>`
  ${({ $topPadding, $bottomPadding }) => {
    return `
      padding-top: ${setPaddingSize($topPadding)}px;
      padding-bottom: ${setPaddingSize($bottomPadding)}px;
    `
  }}

  background: ${({ theme }) => theme.webMktNewPalette.deepBlue[10]};
  .RelatedArticle__Heading {
    color: ${({ theme }) => theme.webMktNewPalette.black};
    font-size: 36px;
    font-weight: 800;
    line-height: 44px;
    margin-bottom: 48px;
  }

  .RelatedArticle__Card-Container {
    display: flex;
    justify-content: center;

    ${({ theme }) => theme.breakpoints.down('sm')} {
      flex-wrap: wrap;
      margin: 0 auto;
      justify-content: start;
    }

    ${({ theme }) => theme.breakpoints.down('xs')} {
      max-width: 328px;
    }
  }

  .RelatedArticle__Image-Container {
    width: 100%;
    position: relative;

    img {
      object-fit: cover;
      object-position: center;
    }

    .RelatedArticle__BackgroundImg {
      width: 100%;
      height: 192px;
    }
  }

  .RelatedArticle__Text-Container {
    padding: 0 24px;
    position: relative;
    margin-top: 32px;

    > *:first-child {
      margin-top: 0;
    }

    ${({ theme }) => theme.breakpoints.down('md')} {
      margin-top: 24px;
    }
  }

  .RelatedArticle__Info-Container {
    display: flex;
    padding: 0 24px;
    position: relative;
    margin-top: 32px;

    > *:first-child {
      margin-top: 0;
    }

    ${({ theme }) => theme.breakpoints.down('md')} {
      margin-top: 24px;
    }
  }

  .RelatedArticle__Item-Date {
    font-size: 12px;
    letter-spacing: 0.5px;
    line-height: 16px;
    color: #8a97a0;
    margin-left: auto;
  }

  .RelatedArticle__Item-Category {
    font-size: 14px;
    text-transform: uppercase;
    color: #8b97a1;
    font-weight: 800;
  }

  .RelatedArticle__Item-Heading {
    margin: 40px 0;
    word-wrap: break-word;

    a {
      color: inherit;
    }

    &:hover {
      color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
    }

    font-size: 20px;
    font-weight: 800;
    color: #273139 !important;
    line-height: 24px;
  }
`
